import { Injectable, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ReauthPopupComponent } from '../reauth-popup.component';
import { SessionInactivityService } from '../../../../services/session-inactivity/session-inactivity.service';
import { LoginService, PractitionerPayload } from '../../../../services/login/login.service';
import { Authorize } from '@privatelib/ngx18-authz-dev';

@Injectable({
  providedIn: 'root'
})
export class ReAuthPopupService {

  constructor(
    private readonly dialog: MatDialog,
    private readonly loginService: LoginService,
    private readonly zone: NgZone,
    private readonly sessionInactivityService: SessionInactivityService,
    private readonly auth: Authorize
  ) { }

  showPopup(emailId: string): Observable<boolean> {
    const dialogRef = this.dialog.open(ReauthPopupComponent, {
      panelClass: 'dialog-class',
      backdropClass: 'dialog-blur-backdrop',
      data: { emailId },
      disableClose: true
    });

    return dialogRef.afterClosed();
  }

  async onReAuth() {
    console.log("on reauth triggered")
    try {
      const emailId = this.auth.getUserDetails()?.email;
      await this.loginService.onPartialLogout();
      this.zone.run(() => {
        this.showPopup(emailId).subscribe(result => this.handleReauthResult(result));
      });
    } catch {
      console.log("error occurred while logging out")
    }
  }

  private handleReauthResult(result: boolean | null | undefined): void {
    const handlers: Record<string, () => void> = {
      true: () => this.handleSuccessfulReauth(),
      false: () => this.handleFailedReauth(),
    };

    // Default to no-op if result is not true or false
    const handler = handlers[String(result)];
    if (handler) {
      handler();
    }
  }

  private handleSuccessfulReauth(): void {
    this.sessionInactivityService.onReInit();
    this.loginService.loggedIn$.next(true);
  }

  private handleFailedReauth(): void {
    this.loginService.revokeOnLogout();
  }

  saveTokenOnReLogin(url: string) {
    const hashIndex = url.indexOf('#');
    if (hashIndex === -1) {
      return;
    }

    const hash = url.substring(hashIndex + 1); // Get part after '#'
    const pairs = hash.split('&'); // Split by & to get key=value pairs
    const result: { [key: string]: string } = {};

    for (const pair of pairs) {
      const [key, value] = pair.split('=');
      if (key && value) {
        result[decodeURIComponent(key)] = decodeURIComponent(value);
      }
    }

    if (result['authToken']) {
      localStorage.setItem('authToken', result['authToken']);
    }

    if (result['idToken']) {
      localStorage.setItem('idToken', result['idToken']);
      const tokenDetails: PractitionerPayload = this.loginService.decodeToken(result['idToken'])
      if (tokenDetails.providerId) {
        localStorage.setItem('providerId', tokenDetails.providerId);
      }
    }

    if (result['refreshToken']) {
      localStorage.setItem('refreshToken', result['refreshToken']);
    }
  }
}
